'use strict';

var _ = require('lodash');
var LadderApproverDetailsService = function LadderApproverDetailsService(configurationService) {
  function isApprovable(data, level, isOnlyApprover) {
    return !!(data.status === 'New' && (level === 'intermediate' || level === 'final' && isOnlyApprover) || data.status === 'Pending' && level === 'final' || data.status === 'Approved' && level === 'final');
  }
  function isUserAuthorizedForCurrentPos(levels, pos) {
    return _.indexOf(levels, pos) !== -1;
  }
  function isUserOnlyApproverForCurrentPos(item) {
    return _.indexOf(configurationService.isOnlyApproverPos(), item.pos) !== -1;
  }
  function getApproveType(item) {
    if (isUserAuthorizedForCurrentPos(configurationService.getUserPrimaryPOSLevel(), item.pos)) {
      return 'intermediate';
    } else if (isUserAuthorizedForCurrentPos(configurationService.getUserLastPOSLevel(), item.pos)) {
      return 'final';
    }
  }
  return {
    isApprovable: isApprovable,
    getApproveType: getApproveType,
    isUserOnlyApproverForCurrentPos: isUserOnlyApproverForCurrentPos
  };
};
LadderApproverDetailsService.$inject = ['ConfigurationService'];
module.exports = LadderApproverDetailsService;